/* eslint-disable max-len */
import { _initialState } from './_initialState';

import {
  digitalDataPushTestEvent,
  customProductPipLoadedEvent,
  pageLoadWithProductImpressionsEvent,
  addItemToStackEvent,
  removeItemsFromStackEvent,
  modalLinkClickEvent,
  zoomModalClickEvent,
  printStackSummaryEvent,
  quickViewModalLoadEvent,
  continueBuildingEvent,
  shareDesignEvent,
  quickViewSectionViewedEvent,
  quickViewPipClickThroughEvent,
  errorInteractionsEvent,
  promotionAccordionsEvent,
  calloutModalLinkClickEvent,
  calloutModalCloseEvent,
  changeCollectionEvent,
  preconfiguredLayoutLinkClickEvent,
  preconfiguredConfirmationModalEvent,

} from './actions';

export const digitalDataStore = (set, get) => ({
  ..._initialState,
  testEvent: () => digitalDataPushTestEvent(set, get),
  trackCustomProductPipLoadedEvent: (
    partnerProductId = '325168962',
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    store,
    pageType
  ) => customProductPipLoadedEvent(
    set, get, partnerProductId,
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    store,
    pageType
  ),
  trackPageLoadWithProductImpressionsEvent: (productData, store, configurator, productInfo) => pageLoadWithProductImpressionsEvent(set, get, productData, store, configurator, productInfo),
  trackAddItemToStackEvent: (sku, basePrice) => addItemToStackEvent(set, get, sku, basePrice),
  trackRemoveItemsFromStackEvent: (target, productArray) => removeItemsFromStackEvent(set, get, target, productArray),
  trackModalLinkClickEvent: (feature, stackDimensions, name) => modalLinkClickEvent(set, get, feature, stackDimensions, name),
  trackCalloutModalLinkClickEvent: (feature, callout) => calloutModalLinkClickEvent(set, get, feature, callout),
  trackCalloutModalCloseEvent: (feature, callout) => calloutModalCloseEvent(set, get, feature, callout),
  trackZoomModalClickEvent: () => zoomModalClickEvent(set, get),
  trackPrintStackSummaryEvent: () => printStackSummaryEvent(set, get),
  trackQuickViewModalLoadEvent: () => quickViewModalLoadEvent(set, get),
  trackContinueBuildingEvent: () => continueBuildingEvent(set, get),
  trackShareDesignEvent: (target, currentUrl) => shareDesignEvent(set, get, target, currentUrl),
  trackQuickViewSectionViewedEvent: (title) => quickViewSectionViewedEvent(set, get, title),
  trackQuickViewPipClickThroughEven: (productType) => quickViewPipClickThroughEvent(set, get, productType),
  trackErrorInteractionsEvent: (errorObject, primaryCategory, eventName) => errorInteractionsEvent(set, get, errorObject, primaryCategory, eventName),
  trackPromotionAccordionsEvent: (target) => promotionAccordionsEvent(set, get, target),
  trackChangeCollectionEvent: () => changeCollectionEvent(set, get),
  trackPreconfiguredLayoutLinkClickEvent: (templateName) => preconfiguredLayoutLinkClickEvent(set, get, templateName),
  trackPreconfiguredConfirmationModalEvent: () => preconfiguredConfirmationModalEvent(set, get)

});
